/** The boot-graph id of Orik's own client module (`harness/orik-harness.ts`), shared by the build and the page. */
export const ORIK_HARNESS_ID = "@vexxhost/atlas-harness";
